import { postRequest } from '@/core';
import { drivers } from '@/requests';

export default async function syncDrivers() {
	let url = drivers.getSyncPath();
	try {
		let response = await postRequest(url);
		return response;
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}